import { useRef, useState } from 'react';
import NewExpenseDetailsModal from "./new-expense-details-modal";

const NewExpensesMobileInputs = ({data, offlineVersion = false, saveExpenses}) => {
  const [expenses, setExpenses] = useState([]);
  const [indexOfDisplayedExpense, setIndexOfDisplayedExpense] = useState(0);
  const fileInputRef = useRef(null);

  const displayedExpense = expenses[indexOfDisplayedExpense];

  const onImagesSelected = (event) => {
    const files = event.target.files;
    
    if (files.length === 0) { return; }

    setExpenses(Array.from(files).map(file => ({
      file,
      description: '',
      isBillable: false,
      matterId: null,
    })));
  }

  const updateExpenseField = (key, value) => {
    const updatedExpenses = [...expenses];
    updatedExpenses[indexOfDisplayedExpense] = {
      ...displayedExpense,
      [key]: value,
    };
    setExpenses(updatedExpenses);
  }

  const onCancel = () => {
    fileInputRef.current.value = '';
    setExpenses([]);
  }

  const onFinish = () => {
    saveExpenses(expenses);

    fileInputRef.current.value = '';
    setExpenses([]);
    setIndexOfDisplayedExpense(0);
  }

  return (
    <>
      <div className="text-center mt-5">
        <label htmlFor="expense-images" className="btn btn-primary btn-cta text-center px-4">
          {data.t.read("add_new_expense")}
          <input type="file" accept="image/*" multiple id="expense-images" style={{display:"none"}} onChange={onImagesSelected} ref={fileInputRef} data-testid="add-new-expense"/>
        </label>
      </div>

      { expenses.length > 0 && (
        <NewExpenseDetailsModal
          key={indexOfDisplayedExpense}
          data={data}
          expense={displayedExpense}
          offlineVersion={offlineVersion}
          updateExpenseField={updateExpenseField}
          hasNext={indexOfDisplayedExpense < expenses.length - 1}
          onNext={() => setIndexOfDisplayedExpense((prev) => prev + 1)}
          hasPrevious={indexOfDisplayedExpense > 0}
          onPrevious={() => setIndexOfDisplayedExpense((prev) => prev - 1)}
          onFinish={onFinish}
          onCancel={onCancel}
        />
      )}
    </>
  )
}

export default NewExpensesMobileInputs;
